import React, { useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import LazyLoading from '../../../components/LazyLoading';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import useSweetAlert from '../../../hooks/useSweetAlert';
import useNavigationPage from '../../../hooks/useNavigationPage';
import usePaymentStatusService from '../../../app/services/hooks/usePaymentStatusService';
import { defaultPaymentStatusDataForm, PaymentStatusCreateFilters, PaymentStatusDataForm, PaymentStatusFilters } from '../../../app/models/PaymentStatus';
import PaymentStatusForm from './forms/PaymentStatusForm';
import { Society } from '../../../app/models/Society';
import SecondPaymentStatusForm from './forms/SecondPaymentStatusForm';
import { DispatchProgram } from '../../../app/models/DispatchProgram';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const PaymentStatusCreate = ({ onSaved, onCancel, onError }: Props) => {

    const [paymentStatus, setPaymentStatus] = useState<PaymentStatusDataForm>(defaultPaymentStatusDataForm);
    const [societies, setSocieties] = useState<Society[]>([]);
    const [clients, setClients] = useState<Client[]>([]);
    const [dispatchPrograms, setDispatchPrograms] = useState<DispatchProgram[]>([]);
    const [paymentStatusFilter, setPaymentStatusFilter] = useState<PaymentStatusCreateFilters>({});
    

    
    const {
        fetchingCreatePaymentStatus,
        fetchingStorePaymentStatus,
        createPaymentStatus,
        storePaymentStatus
    } = usePaymentStatusService();

    const [errorFields, setErrorFields] = useState<any>();
    const { navigationPage } = useNavigationPage();


    useEffect(() => {
        createPaymentStatus(paymentStatusFilter, {
            onSuccess: (response: ServiceResponse) => {
                setDispatchPrograms(response.data.dispatch_programs);
                setSocieties(response.data.societies)
                setClients(response.data.clients)

            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
                if (response.data.to_dashboard) {
                    navigationPage('/');
                }
            },
        })
    }, [paymentStatusFilter]);

    useEffect(() => {
        if(paymentStatus.society_id)
            setPaymentStatusFilter({
                'society_id': paymentStatus.society_id
            })
    }, [paymentStatus.society_id]);
    
    useEffect(() => {
        if(paymentStatus.client_id){
            setPaymentStatusFilter({
                ...paymentStatusFilter,
                'client_id': paymentStatus.client_id
            })
        }
            
    }, [paymentStatus.client_id]);



    const store = () => {
        useSweetAlert().spinnerAlert('Guardando estado de pago...');
        storePaymentStatus(paymentStatus, {
            onSuccess: (response: ServiceResponse) => {
                useSweetAlert().closeSpinnerAlert();
                toast.success(response.message);

                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                useSweetAlert().closeSpinnerAlert();
                toast.error(response.message);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
                if (onError) onError();
            },
            onFieldError: (errorFields: ServiceResponse) => {
                useSweetAlert().closeSpinnerAlert();
                setErrorFields(errorFields.data);
            }
        });
    };


    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingCreatePaymentStatus ? (
        <LazyLoading height={300} />
    ) : (
        <>
            <div className="row">
                <div className="col-12">
                    <SecondPaymentStatusForm 
                        paymentStatus={paymentStatus} 
                        setPaymentStatus={setPaymentStatus}
                        societies={societies}
                        clients={clients}
                        dispatchPrograms={dispatchPrograms}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetchingStorePaymentStatus} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} locked={fetchingStorePaymentStatus} />
                </div>
            </div>
        </>
    );
};

export default PaymentStatusCreate;
